import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App min-h-screen bg-[#05030A] text-[#F3EFE7] antialiased noise">
        <Header />
        <main>
          <Hero />
          <Ribbon />
          <Services />
          <Manifesto />
          <Testimonials />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </ReactLenis>
  );
}

export default App;
